import { combineReducers } from 'redux';
import user from './modules/user/reducer';
import conversations from './modules/conversations/reducers';
import { groupsReducer } from './modules/groups/reducers';
import contacts from './modules/contacts/reducer';
import modals from './modules/modals/reducer';
import messages from './modules/messages/reducer';
import settings from './modules/settings/reducers';
import publicStore from './modules/public/reducer';
import dccReducer from './modules/dcc/reducer';
import notifications from './modules/notifications/reducer';
import ivr from './modules/ivr/reducer';
import forms from './modules/forms/reducer';
import files from './modules/files/reducer';
import connectCards from './modules/connect-cards/reducer';
import notesReducer from './modules/notes/reducer';
import videosReducer from './modules/videos/reducer';

// Calculates the application state.
export const actionReducer = (
  state = {
    type: null,
    payload: null,
    meta: null,
    error: false,
    count: 0,
  },
  action,
) => {
  return {
    ...state,
    ...action,
    count: state.count + 1,
  };
};

export default (history) =>
  combineReducers({
    user,
    modals,
    contacts,
    conversations,
    messages,
    settings,
    notifications,
    forms,
    public: publicStore,
    groups: groupsReducer,
    dcc: dccReducer,
    files,
    connectCards,
    ivr,
    notes: notesReducer,
    videos: videosReducer,
    action: actionReducer,
  });
